import React, { useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import initialize from '../actions/initialize';
import AccessManagement from '../components/AccessManagement';
import ManageSSO from '../components/ManageSSO';
import Users from '../components/Users';
import { persistor } from '../store';
import { nestedRoutes } from './nestedRoutes';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const App = () => {
  const dispatch = useDispatch();
  const { initializing, initialized, error } = useSelector(
    state => state.appAccess,
  );
  useInitialize(dispatch);
  const { application } = useSelector(state => state.sinatra.user.currentRole);

  const returnNestedRoutes = useCallback(() => {
    if (application === 'central_station') {
      let routes = [
        {
          path: 'users',
          component: <Users />,
        },
        {
          path: 'sso',
          component: <ManageSSO />,
        },
      ];
      return routes;
    }
    return nestedRoutes;
  }, [application]);

  return useMemo(() => {
    if (error) {
      return <ErrorPage persistor={persistor} />;
    }
    if (initializing) {
      return <AppLoading />;
    }
    if (initialized) {
      return (
        <AppInnerWrapper>
          <AccessManagement nestedRoutes={returnNestedRoutes()} />
        </AppInnerWrapper>
      );
    }
    return <ErrorPage persistor={persistor} />;
  }, [initializing, initialized, error, returnNestedRoutes]);
};
export default App;
